import type { Feedbacks } from "@/blocks/Feedbacks";
import { useCall } from "@/hooks/useCall/useCall";
import { useGetLine } from "@/hooks/useGetLine/useGetLine";
import { useTrack } from "@/hooks/useTrack/useTrack";

export function useSectionSentiment(): Feedbacks.Props {
  const { track } = useTrack();

  const { call } = useCall();
  const { lineId } = useGetLine();

  const onClickThumbDown = () => {
    track("sentiment_rated_bad", {
      number_id: lineId,
      call_uuid: call?.uuid,
      call_direction: call?.direction,
      transcription_id: call?.transcription?.transcriptionId,
    });
  };
  const onClickThumbDownUpdated = <Type>(previousRating: Type) => {
    track("sentiment_updated", {
      number_id: lineId,
      call_uuid: call?.uuid,
      call_direction: call?.direction,
      transcription_id: call?.transcription?.transcriptionId,
      previous_rating:
        previousRating === "customer_mood.agree" ? "good" : "bad",
      new_rating: "bad",
    });
  };

  const onClickThumbUp = () => {
    track("sentiment_rated_good", {
      number_id: lineId,
      call_uuid: call?.uuid,
      call_direction: call?.direction,
      transcription_id: call?.transcription?.transcriptionId,
    });
  };

  const onClickThumbUpUpdated = <Type>(previousRating: Type) => {
    track("sentiment_updated", {
      number_id: lineId,
      call_uuid: call?.uuid,
      call_direction: call?.direction,
      transcription_id: call?.transcription?.transcriptionId,
      previous_rating:
        previousRating === "customer_mood.agree" ? "good" : "bad",
      new_rating: "good",
    });
  };

  return {
    onClickThumbDown,
    onClickThumbUp,
    onClickThumbUpUpdated,
    onClickThumbDownUpdated,
  };
}
